import { getPathWithParams, NavigationPages, routerPaths } from '@ax/constants';

export const toNavigationPage = (page: string) => {
  if (page.startsWith('/a/notes/')) {
    return NavigationPages.connectedNotes;
  }

  switch (page) {
    case routerPaths.notes:
      return NavigationPages.Notes;
    case routerPaths.settings:
      return NavigationPages.Settings;
    case routerPaths.login:
      return NavigationPages.Login;
    case routerPaths.support:
      return NavigationPages.Support;
    case routerPaths.adminNotes:
      return NavigationPages.AdminNotes;
    default:
      return NavigationPages.Notes;
  }
};

export const toRouterPath = (page: NavigationPages, params?: Record<string, string>) => {
  switch (page) {
    case NavigationPages.Notes:
      return routerPaths.notes;
    case NavigationPages.Settings:
      return routerPaths.settings;
    case NavigationPages.Login:
      return routerPaths.login;
    case NavigationPages.AdminNotes:
      return routerPaths.adminNotes;
    case NavigationPages.connectedNotes:
      return getPathWithParams(routerPaths.connectedNotes, params || {});
    default:
      return routerPaths.notes;
  }
};
